<template>
    <div class="titulo-section">
        <h2 class="titulo-text fuente-posm">
            Incrementa la Lealtad y Genera Relaciones.
        </h2>
    </div>
</template>

<script>
export default {
    name: 'TituloLealtadNew'
}
</script>

<style lang="css" scoped>
.titulo-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    box-sizing: border-box;
    scroll-snap-align: start;
    background-color: #272727;
}

.titulo-text {
    color: var(--color-5);
    font-size: 80px;
    line-height: 1.1;
    text-align: center;
    max-width: 850px;
    margin: 0;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .titulo-text {
        font-size: 70px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .titulo-section {
        padding: 20px;
    }

    .titulo-text {
        font-size: 35px;
    }
}
</style>
